<template>
    <div>
        <el-input
            v-if="enabled"
            :model-value="value"
            v-bind="$attrs"
            type="textarea"
            @update:modelValue="(val) => $emit('input', val)"
        />
        <span v-else style="white-space: pre">{{ value }}</span>
    </div>
</template>

<script>
    import { ElInput } from 'element-plus';

    export default {
        name: 'CicTextarea',
        components: {
            'el-input': ElInput,
        },
        props: {
            enabled: {
                type: Boolean,
                default: true,
            },
            value: {
                type: String,
                default: null,
            },
        },
        emits: ['input'],
    };
</script>
